// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file feedback.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Reservation } from "./reservation_pb";
import { file_reservation } from "./reservation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file feedback.proto.
 */
export const file_feedback: GenFile = /*@__PURE__*/
  fileDesc("Cg5mZWVkYmFjay5wcm90bxILZ3JwYy5hcGkudjEi4QIKCEZlZWRiYWNrEgoKAmlkGAEgASgDEhYKDnJlc2VydmF0aW9uX2lkGAIgASgDEhMKC2Zvb2RfcmF0aW5nGAMgASgFEhYKDnNlcnZpY2VfcmF0aW5nGAQgASgFEhcKD2FtYmllbmNlX3JhdGluZxgFIAEoBRIWCg5vdmVyYWxsX3JhdGluZxgGIAEoBRIQCghjb21tZW50cxgHIAEoCRIRCglkdF9jcmVhdGUYCCABKAMSEQoJaXNfcHVibGljGAkgASgIEhwKFHJlc2VydmF0aW9uX2R0X2JlZ2luGAogASgDEhQKDGNvbnRhY3RfbmFtZRgLIAEoCRIhChljb250YWN0X3Jlc2VydmF0aW9uX2NvdW50GAwgASgFEhUKDWR0X3JlcGxpZWRfYXQYDSABKAMSLQoLcmVzZXJ2YXRpb24YDiABKAsyGC5ncnBjLmFwaS52MS5SZXNlcnZhdGlvbkIGWgQuO3BiYgZwcm90bzM", [file_reservation]);

/**
 * Feedback
 *
 * @generated from message grpc.api.v1.Feedback
 */
export type Feedback = Message<"grpc.api.v1.Feedback"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 reservation_id = 2;
   */
  reservationId: bigint;

  /**
   * @generated from field: int32 food_rating = 3;
   */
  foodRating: number;

  /**
   * @generated from field: int32 service_rating = 4;
   */
  serviceRating: number;

  /**
   * @generated from field: int32 ambience_rating = 5;
   */
  ambienceRating: number;

  /**
   * @generated from field: int32 overall_rating = 6;
   */
  overallRating: number;

  /**
   * @generated from field: string comments = 7;
   */
  comments: string;

  /**
   * @generated from field: int64 dt_create = 8;
   */
  dtCreate: bigint;

  /**
   * @generated from field: bool is_public = 9;
   */
  isPublic: boolean;

  /**
   * @generated from field: int64 reservation_dt_begin = 10;
   */
  reservationDtBegin: bigint;

  /**
   * @generated from field: string contact_name = 11;
   */
  contactName: string;

  /**
   * @generated from field: int32 contact_reservation_count = 12;
   */
  contactReservationCount: number;

  /**
   * @generated from field: int64 dt_replied_at = 13;
   */
  dtRepliedAt: bigint;

  /**
   * @generated from field: grpc.api.v1.Reservation reservation = 14;
   */
  reservation?: Reservation | undefined;
};

/**
 * Describes the message grpc.api.v1.Feedback.
 * Use `create(FeedbackSchema)` to create a new message.
 */
export const FeedbackSchema: GenMessage<Feedback> = /*@__PURE__*/
  messageDesc(file_feedback, 0);

